import { useBackend } from "../../services";
import { IEquipment } from "./interfaces";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import { IGetPaginatedAttributeProps } from "../attributes/interfaces";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetEquipments = (setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const [currentUser] = useUser.useState();
  const getEquipments = (parameters: IGetPaginatedAttributeProps) => get("equipments", parameters);
  return useGetPaginatedAttributes<IEquipment>(
    PageSizeHelper.equipments(currentUser?.role ?? UserRole.common),
    getEquipments,
    setLoading,
    DataStorage.equipmentsStorage,
    false,
    true,
    undefined
  );
};
